import React, { useEffect, useState } from 'react';
import SVG12 from '../../MI-Result-Images/1-2.jsx';
import SVG23 from '../../MI-Result-Images/2-3.jsx';
import SVG34 from '../../MI-Result-Images/3-4.jsx';
import SVG45 from '../../MI-Result-Images/4-5.jsx';
import SVG1 from '../../MI-Result-Images/1.jsx';
import SVG2 from '../../MI-Result-Images/2.jsx';
import SVG3 from '../../MI-Result-Images/3.jsx';
import SVG4 from '../../MI-Result-Images/4.jsx';
import SVG5 from '../../MI-Result-Images/5.jsx';
// import SvgWithLabels from '../../Maturity-Index-Result-Visualisation-2Jul2025/Set2/SvgWithLabels.jsx';

const ApexChart = ({ totalScore, organization }) => {
  const [svgComponent, setSvgComponent] = useState(null);
    
  const score = parseFloat(totalScore);

  useEffect(() => {
    let component = null;

    const props = {
      companyText: `Company: ${organization}`,
      numberText: `Number: ${totalScore}`,
    };

    if (score === 1) {
      component = <SVG1 {...props} company={organization} score={score}/>;
    } else if (score > 1 && score < 2) {
      component = <SVG12 {...props} company={organization} score={score}/>;
    } else if (score === 2) {
      component = <SVG2 {...props} company={organization} score={score} />;
    } else if (score > 2 && score < 3) {
      component = <SVG23 {...props} company={organization} score={score}/>;
    } else if (score === 3) {
      component = <SVG3 company={organization} score={score} />; // ✅ Using SvgWithLabels
    } else if (score > 3 && score < 4) {
      component = <SVG34 {...props} company={organization} score={score} />;
    } else if (score === 4) {
      component = <SVG4 {...props} company={organization} score={score} />;
    } else if (score > 4 && score < 5) {
      component = <SVG45 {...props} company={organization} score={score} />;
    } else {
      component = <SVG5 {...props} company={organization} score={score} />;
    }

    setSvgComponent(component);
  }, [score, organization, totalScore]);

  return (
    <div style={{ position: 'relative', margin: '0 auto' }}>
      {svgComponent && (
        <div style={{ top: 0, left: 0, width: '100%' }}>
          {svgComponent} {/* ✅ Use svgComponent, not component */}
        </div>
      )}
    </div>
  );
};

export default ApexChart;
